import { useQuery } from '@tanstack/react-query';
import type { User } from '@lingaai/types';

interface PaginatedUsersResponse {
  data: User[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

interface UseUsersFilters {
  search?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

async function listUsers(tenantId: string, filters?: UseUsersFilters): Promise<PaginatedUsersResponse> {
  const params = new URLSearchParams();
  params.append('tenant_id', tenantId);

  if (filters?.search) params.append('search', filters.search);
  if (filters?.page) params.append('page', filters.page.toString());
  if (filters?.pageSize) params.append('pageSize', filters.pageSize.toString());
  if (filters?.sortBy) params.append('sortBy', filters.sortBy);
  if (filters?.sortOrder) params.append('sortOrder', filters.sortOrder);

  const apiUrl = (import.meta as any).env?.VITE_API_URL || 'http://localhost:3000';
  const response = await fetch(`${apiUrl}/users?${params.toString()}`);

  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }

  return response.json();
}

export function useUsers(tenantId: string | null | undefined, filters?: UseUsersFilters) {
  return useQuery({
    queryKey: ['users', tenantId, filters],
    queryFn: () => listUsers(tenantId!, filters),
    enabled: !!tenantId,
  });
}
